
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20.9902 17.99L16.0502 13.05L13.9302 15.17L18.8702 20.11C19.4602 20.7 20.4102 20.7 20.9902 20.11C21.5702 19.52 21.5702 18.57 20.9902 17.99Z' fill='#323232'/><path d='M17.65 10C19.58 10 21.15 8.43 21.15 6.5C21.15 5.92 20.99 5.38 20.74 4.9L18.04 7.6L16.55 6.11L19.25 3.41C18.77 3.16 18.23 3 17.65 3C15.72 3 14.15 4.57 14.15 6.5C14.15 6.91 14.23 7.3 14.36 7.66L12.51 9.51L10.73 7.73C11.12 7.34 11.12 6.71 10.73 6.32L10.02 5.61L12.14 3.49C10.97 2.32 9.07004 2.32 7.90004 3.49L5.08004 6.32C4.69004 6.71 4.69004 7.34 5.08004 7.73L5.79004 8.44H3.25004C3.06004 8.44 2.88004 8.51 2.75004 8.65C2.47004 8.93 2.47004 9.37 2.75004 9.65L5.29004 12.19C5.57004 12.47 6.01004 12.47 6.29004 12.19C6.42004 12.06 6.50004 11.88 6.50004 11.69V9.15L7.20004 9.85C7.59004 10.24 8.22004 10.24 8.61004 9.85L10.39 11.63L4.04004 17.98C3.45004 18.57 3.45004 19.52 4.04004 20.1C4.63004 20.69 5.58004 20.69 6.16004 20.1L16.48 9.79C16.85 9.92 17.24 10 17.65 10Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-construction`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconConstruction

    ```js
    <b-new-b-icon-construction />
    ```
</docs>


